/*
 * @Author: your name
 * @Date: 2021-09-18 17:00:01
 * @LastEditTime: 2021-10-19 14:31:13
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\router\modules\mallRouter.js
 */
import Layout from '@/views/layout'
const mallRouter = [
    {
        path: '/article',
        component: Layout,
        children: [
            {
                path: 'articleList',
                component: () => import('@/views/article/articleList'),
                name: 'articleList',
                meta: { title: '新闻公告', icon: '', affix: true}
            },
            {
                path: 'articleDetail',
                component: () => import('@/views/article/articleDetail'),
                name: 'articleDetail',
                meta: { title: '新闻公告详情', icon: '', affix: true}
            }
        ]
    }
]
export default mallRouter;


// WEBPACK FOOTER //
// ./src/router/modules/mallRouter.js